"use client"

import { useEffect, useState } from "react"
import Link from "next/link"
import { loadOrderByIdAction, loadRequisition } from "@/actions/orderActions"
import { useUbStorefrontState } from "@/store/ubStorefrontState"

import { CheckoutContext } from "@/lib/storefront/checkout/checkout-service"
import { Button } from "@/components/ui/components"
import { UbCheckoutConfirmationOrderLinkStoryblok } from "@/components/storyblok/component-types"
import { StopActionWorkflow } from "@/lib/intershop/interfaces/order/order"

interface CheckoutConfirmationProps {
  blok: UbCheckoutConfirmationOrderLinkStoryblok
  checkoutContext: CheckoutContext
}

export default function CheckoutConfirmationOrderLinkClient(props: CheckoutConfirmationProps) {
  const { createdOrder } = useUbStorefrontState()
  const [orderDocumentNumber, setOrderDocumentNumber] = useState<string>("")
  const [orderId, setOrderId] = useState<string>("")

  useEffect(() => {
    if (createdOrder) {
      if (
        createdOrder?.orderCreation?.status === "STOPPED" &&
        (createdOrder?.orderCreation?.stopAction as StopActionWorkflow)?.exitReason === "approval_workflow"
      ) {
        // Do not load order details if approval workflow is active, as order is not created yet
        setOrderId(createdOrder.basket || "")
        if (createdOrder.basket) {
          loadRequisition(
            props.checkoutContext.customerData,
            props.checkoutContext.userData,
            createdOrder.basket
          ).then((requisition) => {
            setOrderDocumentNumber(requisition?.data?.requisitionNo ?? "")
          })
        } else {  
          setOrderDocumentNumber(createdOrder?.basket || "")
        }
      } else {
        setOrderId(createdOrder.id)
        loadOrderByIdAction(createdOrder.id).then((order) => {
          setOrderDocumentNumber(order?.data?.documentNumber ?? "")
        })
      }
    }
  }, [createdOrder])

  return (
    <>
      {createdOrder && orderDocumentNumber !== "" ? (
        <Link prefetch={false} className={"cursor-pointer"} href={props.blok.orderDetailLink + "" + orderId}>
          {props.blok.showAsButton ? (
            <Button size={"defaultNoGrow"} variant={"default"} className={"bg-primary py-0 font-normal text-white"}>
              {props.blok.buttonTitle ?? "Order details"}
            </Button>
          ) : (
            <p className={"text-sm font-bold text-primary sm:text-lg"}>{orderDocumentNumber}</p>
          )}
        </Link>
      ) : (
        <>
          {props.blok.showAsButton ? (
            <Button size={"defaultNoGrow"} variant={"default"} className={"bg-primary py-0 font-normal text-white"}>
              {props.blok.buttonTitle ?? "Order details"}
            </Button>
          ) : (
            <p className={"text-sm font-bold text-primary sm:text-lg"}></p>
          )}
        </>
      )}
    </>
  )
}
